import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** bound book, journal. Decorative line icon; always pair with a visible text label. */
export function JournalIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </IconSvg>
  )
}
